import React from 'react'
import { Row, Col } from 'antd';


export default function Verification(props){

    console.log(props)

    const style = {
        row:{
            padding:"10px"
        }
    }


    return (
        <div style={style.row}>
                <Row style={style.row}>
                    <Col span={4}>Name</Col><Col span={4} >{props.employee.first_name + " " + props.employee.last_name}</Col>
                </Row>
                <Row style={style.row}>
                    <Col span={4}>NIC</Col><Col span={4} >{props.employee.NIC}</Col>
                </Row>
                <Row style={style.row}>
                    <Col span={4} >Address</Col>
                    <Col span={4} >
                        {
                            props.employee.address_no 
                            + "," + props.employee.address_street 
                            + "," + props.employee.address_town
                            + "." + props.employee.address_district
                        }
                    </Col>
                </Row>
                <Row style={style.row}>
                    <Col span={4}> Contact No</Col><Col span={4} >{props.employee.contact_no }</Col>
                </Row>
                <Row style={style.row}>
                    <Col span={4}> Job Type</Col><Col span={4} >{props.employee.EmployeeTypeTitle }</Col>
                </Row>
                <Row style={style.row}>
                    <Col span={4}> entity</Col><Col span={4} >{props.employee.entity}</Col>
                </Row>
            </div> 
    )
}